@if (form) {
<form lin-layout-form [formGroup]="form" (ngSubmit)="installDevice()">
  <div fxLayout="column">
    <div fxLayoutAlign="flex-start center">
      <lin-form-label required class="label">{{ 'ADMIN.DEVICES.DEVICE_IMEI' | translate }}</lin-form-label>
      <mat-form-field class="form-field">
        <input matInput formControlName="imei" />
        <mat-error>
          <lin-form-field-error [control]="form.get('imei')" controlName="imei"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      <span>{{ 'ADMIN.DEVICES.MODEL' | translate }}: {{ deviceInstallationData?.device?.model?.id }}</span><br />
      <span>{{ 'ADMIN.DEVICES.PHONE_NUMBER' | translate }}: {{ deviceInstallationData?.device?.phone }}</span>
    </div>
  </div>

  <div fxLayout="column" fxFlexOffset="10">
    <div fxLayoutAlign="flex-start center">
      <lin-form-label required class="label">{{ 'ADMIN.DEVICES.VEHICLE_REG_NUMBER' | translate }}:</lin-form-label>
      <mat-form-field class="form-field">
        <input matInput formControlName="regNo" />
        <mat-error>
          <lin-form-field-error [control]="form.get('regNo')" controlName="regNo"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      <span>{{ 'ADMIN.DEVICES.MODEL' | translate }}: {{ deviceInstallationData?.vehicle?.model }}</span><br />
      @if (!isClientUser) {
      <span> {{ 'ADMIN.DEVICES.CLIENT' | translate }}: {{ deviceInstallationData?.vehicle?.team?.clientName }}</span>
      }
    </div>

    @if (errorMessage) {
    <div class="error-message"><mat-icon>error</mat-icon> {{ errorMessage }}</div>
    }

    <lin-form-submit-button
      fxLayoutAlign="center"
      [isDisabled]="form.invalid && deviceInstallationData?.id"
      [isLoading]="isSubmitting"
      fxFlexOffset="10px"
    >
      {{ 'ADMIN.DEVICES.LINK_NEW_DEVICE' | translate }}
    </lin-form-submit-button>
  </div>
</form>
}
